// ===================================================
// Contact.jsx (Production Ready - Google Maps Embed)
// ===================================================
import React from "react";
import { motion } from "framer-motion";
import ContactForm from "../components/ContactForm";
import { FaMapMarkerAlt, FaPhone, FaEnvelope, FaClock } from "react-icons/fa";
import "../styles/Contact.css";

// ✅ Your location (Chennai)
const LAT = 12.9585405;
const LNG = 80.1931274;

const Contact = () => {
  // Animations
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { when: "beforeChildren", staggerChildren: 0.2 },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.6 } },
  };

  return (
    <motion.div
      className="page-container contact-page"
      initial="hidden"
      animate="visible"
      variants={containerVariants}
    >
      {/* Header */}
      <motion.div variants={itemVariants} className="contact-header">
        <h1 className="page-title">Get In Touch</h1>
        <p className="page-subtitle">
          Reach out to us for catering or chef bookings. We’re here to make your
          events memorable with authentic cuisine.
        </p>
      </motion.div>

      {/* Content */}
      <div className="contact-content">
        {/* Form */}
        <motion.div variants={itemVariants} className="contact-form-container">
          <h2 className="section-title">Send Us a Message</h2>
          <ContactForm />
        </motion.div>

        {/* Info + Map */}
        <motion.div variants={itemVariants} className="contact-info-container">
          {/* Contact Details */}
          <div className="contact-details">
            {/* Location */}
            <motion.div className="contact-card" whileHover={{ scale: 1.03 }}>
              <div className="contact-icon">
                <FaMapMarkerAlt />
              </div>
              <div className="contact-text">
                <h3>Location</h3>
                <p>
                  Dr. Ramamurthy Nagar, Gandhi St,
                  <br /> Keelkattalai, Chennai - 600117
                </p>
              </div>
            </motion.div>

            {/* Phone */}
            <motion.div className="contact-card" whileHover={{ scale: 1.03 }}>
              <div className="contact-icon">
                <FaPhone />
              </div>
              <div className="contact-text">
                <h3>Phone</h3>
                <p>
                  <a href="tel:+918939215616" className="contact-link">
                    +91 89392 15616
                  </a>
                </p>
              </div>
            </motion.div>

            {/* Email */}
            <motion.div className="contact-card" whileHover={{ scale: 1.03 }}>
              <div className="contact-icon">
                <FaEnvelope />
              </div>
              <div className="contact-text">
                <h3>Email</h3>
                <p>
                  <a
                    href="mailto:sacs-info@zohomail.in"
                    className="contact-link"
                  >
                    sacs-info@zohomail.in
                  </a>
                </p>
              </div>
            </motion.div>

            {/* Hours */}
            <motion.div className="contact-card" whileHover={{ scale: 1.03 }}>
              <div className="contact-icon">
                <FaClock />
              </div>
              <div className="contact-text">
                <h3>Working Hours</h3>
                <p>Mon–Fri: 7:30 AM – 6:30 PM</p>
                <p>Sat–Sun: 7:30 AM – 3:30 PM</p>
              </div>
            </motion.div>
          </div>

          {/* Google Map */}
          <motion.div
            initial={{ opacity: 0, scale: 0.95 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ delay: 0.4, duration: 0.5 }}
            className="map-container"
          >
            <h3 className="map-title">Find Us Here</h3>

            <div
              className="map-wrapper"
              style={{
                width: "100%",
                height: "300px",
                borderRadius: "12px",
                overflow: "hidden",
                boxShadow: "0 10px 30px rgba(0,0,0,0.15)",
              }}
            >
              <iframe
                title="Google Map Location"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                loading="lazy"
                allowFullScreen
                referrerPolicy="no-referrer-when-downgrade"
                src={`https://www.google.com/maps?q=${LAT},${LNG}&z=15&output=embed`}
              />
            </div>

            {/* Optional: Open in Google Maps */}
            <a
              href={`https://www.google.com/maps?q=${LAT},${LNG}`}
              target="_blank"
              rel="noopener noreferrer"
              className="contact-link"
              style={{ display: "inline-block", marginTop: "0.75rem" }}
            >
              Open in Google Maps
            </a>
          </motion.div>
        </motion.div>
      </div>
    </motion.div>
  );
};

export default Contact;
